const Auth = {
    login        : r => require.ensure([], () => r(require('../components/auth/login_en')),         'auth'),
    login_ar     : r => require.ensure([], () => r(require('../components/auth/login_ar')),         'auth'),
    user_choice  : r => require.ensure([], () => r(require('../components/auth/user_choice')),         'auth'),
    user_license : r => require.ensure([], () => r(require('../components/auth/user_license')),         'auth'),
    user_entity_license : r => require.ensure([], () => r(require('../components/auth/user_entity_license')),         'auth'),
    confirmation : r => require.ensure([], () => r(require('../components/auth/confirmation')),         'auth')
}
const manageCourse = {
    index:       r => require.ensure([], () => r(require('../components/list/index')),         'manage-course'),
    general:      r => require.ensure([], () => r(require('../components/list/general')),           'manage-course'),
    notification: r => require.ensure([], () => r(require('../components/list/notification')), 'manage-course'),
    completion:       r => require.ensure([], () => r(require('../components/list/completion')),       'manage-course'),
    enrolments:       r => require.ensure([], () => r(require('../components/list/enrolments')),       'manage-course')
};
const manageSetting = {
    index:       r => require.ensure([], () => r(require('../components/setting/index')),         'manage-setting'),
    general:      r => require.ensure([], () => r(require('../components/setting/general')),           'manage-setting'),
    gamification:      r => require.ensure([], () => r(require('../components/setting/gamification')),           'manage-setting'),
    certificate: r => require.ensure([], () => r(require('../components/setting/certificate')), 'manage-setting'),
    notificationstemplates:       r => require.ensure([], () => r(require('../components/setting/notificationstemplates')),       'manage-setting')
};
const editCourse = {
    editindex:       r => require.ensure([], () => r(require('../components/edit/editindex')),         'edit-course'),
    general:      r => require.ensure([], () => r(require('../components/edit/editgeneral')),           'edit-course'),
    notification: r => require.ensure([], () => r(require('../components/edit/editnotification')), 'edit-course'),
    completion:       r => require.ensure([], () => r(require('../components/edit/editcompletion')),       'edit-course'),
    enrolments:       r => require.ensure([], () => r(require('../components/edit/editenrolments')),       'edit-course')
};
import  * as component  from './components'
export default [
    {
        name: 'lms.login',
        path: '/lms/login',
        component: Auth.login,
        meta: { requiresAuth: false },
    },
    {
        name: 'lms.login_ar',
        path: '/lms/login_ar',
        component: Auth.login_ar,
        meta: { requiresAuth: false },
    },
    {
        name: 'lms.user_choice',
        path: '/lms/user_choice',
        component: Auth.user_choice,
        meta: { requiresAuth: false },
    },
    {
        name: 'lms.user_license',
        path: '/lms/user_license',
        component: Auth.user_license,
        meta: { requiresAuth: false },
    },
    {
        name: 'lms.user_entity_license',
        path: '/lms/user_entity_license',
        component: Auth.user_entity_license,
        meta: { requiresAuth: false },
    },
    {
        name: 'lms.confirmation',
        path: '/lms/confirmation',
        component: Auth.confirmation,
        meta: { requiresAuth: false },
    },
    {
      name: 'lms.courses',
      path: '/',
      component: component.courses,
    },
    {
      name: 'lms.courses2',
      path: '/lms/courses',
      component: component.courses,
    },
    {
        name: 'lms.index',
        path: '/lms/general/:id',
        component: manageCourse.index,
        redirect: { name:'lms.general/:id'},
        children: [
            {
                name: 'lms.general',
                path: '/lms/general/:id',
                component: manageCourse.general,
            },
            {
                name: 'lms.notification',
                path: '/lms/notification/:id',
                component: manageCourse.notification,
            },
            {
                name: 'lms.completion',
                path: '/lms/completion/:id',
                component: manageCourse.completion,
            },
            {
                name: 'lms.enrolments',
                path: '/lms/enrolments/:id',
                component: manageCourse.enrolments,
            }
        ]
    },
    {
        name: 'lms.editindex',
        path: '/lms/editgeneral/:id',
        component: editCourse.editindex,
        redirect: { name:'lms.editgeneral'},
        children: [
            {
                name: 'lms.editgeneral',
                path: '/lms/editgeneral/:id',
                component: editCourse.editgeneral,
            },
            {
                name: 'lms.editnotification',
                path: '/lms/editnotification/:id',
                component: editCourse.editnotification,
            },
            {
                name: 'lms.editcompletion',
                path: '/lms/editcompletion/:id',
                component: editCourse.editcompletion,
            },
            {
                name: 'lms.editenrolments',
                path: '/lms/editenrolments/:id',
                component: editCourse.editenrolments,
            }
        ]
    },
    {
        name: 'lms.index',
        path: '/lms/setting',
        component: manageSetting.index,
        redirect: { name:'lms.setting'},
        children: [
            {
                name: 'lms.setting',
                path: '/lms/setting',
                component: manageSetting.general,
            },
            {
                name: 'lms.gamification',
                path: '/lms/gamification',
                component: manageSetting.gamification,
            },
            {
                name: 'lms.certificate',
                path: '/lms/certificate',
                component: manageSetting.certificate,
            },
            {
                name: 'lms.notificationstemplates',
                path: '/lms/notificationstemplates',
                component: manageSetting.notificationstemplates,
            }
        ]
    },
    {
      name: 'lms.reports',
      path: '/lms/reports',
      component: component.Reports,
    },
    {
      name: 'lms.reportcourses',
      path: '/lms/reports/courses',
      component: component.Courses,
    },
    {
      name: 'lms.license',
      path: '/lms/reports/license',
      component: component.License,
    },
    {
      name: 'lms.learner_results',
      path: '/lms/reports/learner_results',
      component: component.Courses,
    },
    {
      name: 'lms.reportdepartments',
      path: '/lms/reports/departments',
      component: component.Departments,
    },
    {
      name: 'lms.reportlearners',
      path: '/lms/reports/learners',
      component: component.Learners,
    },
    {
      name: 'lms.reportdepartment_targets',
      path: '/lms/reports/department_targets',
      component: component.DepartmentTargets,
    },
    {
      name: 'lms.reporttarget_courses',
      path: '/lms/reports/target_courses',
      component: component.TargetCourses,
    },
    {
      name: 'lms.emaillogs',
      path: '/lms/emaillogs',
      component: component.Emaillogs,
    }
]



// WEBPACK FOOTER //
// ./src/app/lms/routes/index.js